module.exports = __webpack_public_path__ + "media/brands/polaris-30fe831a.png";